<template>
  <template v-for="item in srchres" :key="item">
    <div
      v-if="item.visible !== 'N'"
      class="result fade-in"
      :class="[
        setbrandid == 'PIT'
          ? !item.grand_total ||
            item.grand_total == '0.00' ||
            item.booking_applicable == 'N'
            ? 'result-disabled '
            : ' '
          : (!item.grand_total ||
              item.grand_total == '0.00' ||
              item.booking_applicable == 'N') &&
            parseInt(item.occupancy_percentage) < 100
          ? 'result-disabled '
          : ' ',
        cpkdetails.clients[item.cpk_pro].featured_product === 'true' &&
        cpkdetails.clients[item.cpk_pro].product_feature_name
          ? 'featured-product'
          : '',
        `product-id-${item.product_id}`,
      ]"
    >
      <div
        class="featured-product-header"
        v-if="
          cpkdetails.clients[item.cpk_pro].featured_product === 'true' &&
          cpkdetails.clients[item.cpk_pro].product_feature_name
        "
      >
        {{ cpkdetails.clients[item.cpk_pro].product_feature_name }}
      </div>
      <!-- Grid version -->
      <div class="result-grid">
        <div class="result__parking-icon" :class="color">
          <!-- grid image here -->
          <img
            :src="
              get_lang_image(cpkdetails.clients[item.cpk_pro], 'grid_image')
            "
            alt="carpark product image"
          />
        </div>
        <h3 class="result__headline">
          <span class="result_product_display_name">{{
            getrans(item.product_display_name)
          }}</span>
          <!-- <span class="result_carpark_name"> ( {{ getrans(item.carpark_name) }} ) </span> -->
        </h3>
        <div class="result__right-row-01">
          <div class="result__distance">
            <div class="result__info-time">
              <span v-if="get_distances_data(item.carpark_id)">{{
                getrans(get_distances_data(item.carpark_id))
              }}</span>
              <span v-else>{{
                getrans(cpkdetails.clients[item.cpk_pro].distance_in_time_1)
              }}</span>
            </div>
            <div class="result__info-text">
              <div class="result__info-transfer">
                <img
                  v-if="cpkdetails.clients[item.cpk_pro].transfer_icon"
                  :src="cpkdetails.clients[item.cpk_pro].transfer_icon"
                />
                <img v-else src="@/assets/images/awesome-walking.svg" />
                {{
                  getrans(
                    cpkdetails.clients[item.cpk_pro].transfer_label ||
                      "To Terminal"
                  )
                }}
              </div>
            </div>
          </div>

          <!-- RDU -->
          <div
            class="result__cost"
            v-if="
              setbrandid == 'RDU' ||
              setbrandid == 'DRW' ||
              setbrandid == 'YHM' ||
              setbrandid == 'SV1' ||
              setbrandid == 'OKC' ||
              setbrandid == 'LAX' ||
              setbrandid == 'DEN' ||
              setbrandid == 'SAT' ||
              setbrandid == 'AUH' ||
              setbrandid == 'INV' ||
              setbrandid == 'IP1' ||
              setbrandid == 'LDY' ||
              setbrandid == 'NOC' ||
              setbrandid == 'NQY' ||
              setbrandid == 'BHX' ||
              setbrandid == 'SV1' ||
              setbrandid == 'PIT' ||
              setbrandid == 'HVN' ||
              setbrandid == 'YHM' ||
              setbrandid == 'JER' ||
              setbrandid == 'PB1' ||
              setbrandid == 'PV1'
            "
          >
            <template v-if="setbrandid === 'LAX'">
              <template
                v-if="
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                  0
                "
              >
                <span>{{ getrans("Drive-up rate") }}</span>
                <span class="result__info-cost-total_amount">
                  {{
                    currency_formatter(
                      parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                        2
                      )
                    )
                  }}
                </span>
              </template>
            </template>
            <div class="result__info-cost">
              <span class="result__info-cost-grand_total">
                {{
                  currency_formatter(
                    setbrandid === 'HVN'
                      ? getDisplayPrice(item)
                      : parseFloat(item.grand_total).toFixed(2)
                  )
                }}
              </span>
              <span
                class="result__info-cost-total_amount"
                v-if="
                  setbrandid != 'LAX' &&
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                    0
                "
              >
                {{
                  currency_formatter(
                    parseFloat(item.calculations[0].gate_rate_amount).toFixed(2)
                  )
                }}
              </span>
            </div>
            <div
              class="result__info-text"
              v-if="
                parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                  parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                  0
              "
            >
              <template v-if="setbrandid === 'LAX'"></template>
              <template v-else-if="setbrandid === 'PIT'">
                {{ getrans("Save") }} $
                {{
                  (
                    parseFloat(item.calculations[0].gate_rate_amount) -
                    parseFloat(item.grand_total)
                  ).toFixed(0)
                }}
              </template>
              <template v-else-if="setbrandid === 'NQY'">
                {{ getrans("Save") }}
                {{
                  (
                    ((parseFloat(item.calculations[0].gate_rate_amount) -
                      parseFloat(item.grand_total)) /
                      item.calculations[0].gate_rate_amount) *
                    100
                  ).toFixed(2)
                }}%
                {{ getrans("Online Discount") }}
              </template>
              <template v-else-if="setbrandid != 'SV1'">
                {{ setbrandid === "PB1" ? "" : getrans("Save") }}&nbsp;{{
                  (
                    ((parseFloat(item.calculations[0].gate_rate_amount) -
                      parseFloat(item.grand_total)) /
                      item.calculations[0].gate_rate_amount) *
                    100
                  ).toFixed(setbrandid === "PB1" ? 0 : 2)
                }}%&nbsp;{{ setbrandid === "PB1" ? getrans("Save") : "" }}
              </template>
              <template v-else>
                {{
                  (
                    ((parseFloat(item.calculations[0].gate_rate_amount) -
                      parseFloat(item.grand_total)) /
                      item.calculations[0].gate_rate_amount) *
                    100
                  ).toFixed(0)
                }}%
                {{ getrans("Online Discount") }}
              </template>
            </div>
            <template v-if="setbrandid === 'LAX'">
              <span class="text-below-price">{{
                getrans("Includes all taxes & fees")
              }}</span>
            </template>
          </div>

          <!-- HER -->
          <div class="result__cost" v-else-if="setbrandid == 'HER'">
            <div class="result__info-cost">
              <span class="result__info-cost-grand_total">
                {{
                  currency_formatter(
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2) -
                      parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                        2
                      ) >
                      0
                      ? parseFloat(
                          item.calculations[0].gate_rate_amount
                        ).toFixed(2)
                      : parseFloat(Math.ceil(item.grand_total)).toFixed(2)
                  )
                }}
              </span>
              <span
                class="result__info-cost-total_amount"
                v-if="
                  parseFloat(item.total_discount) > 0 ||
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                    0
                "
              >
                {{
                  currency_formatter(
                    parseFloat(item.calculations[0].gate_rate_amount).toFixed(2)
                  )
                }}
              </span>
            </div>
            <div
              class="result__info-text"
              v-if="
                parseFloat(item.total_discount) > 0 ||
                parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                  parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                  0
              "
            >
              {{ getrans("Save") }}
              {{
                (
                  ((parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                    2
                  ) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2)) /
                    parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                      2
                    )) *
                  100
                ).toFixed(2)
              }}%
            </div>
          </div>

          <!-- default -->
          <div class="result__cost" v-else>
            <div class="result__info-cost">
              <span
                class="result__info-cost-grand_total"
                v-if="setbrandid == 'HVN'"
              >
                {{
                  currency_formatter(parseFloat(item.grand_total).toFixed(2))
                }}
              </span>
              <span class="result__info-cost-grand_total" v-else>
                {{
                  currency_formatter(
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2)
                  )
                }}
              </span>
              <span
                class="result__info-cost-total_amount"
                v-if="
                  setbrandid != 'HVN' &&
                  (parseFloat(item.total_discount) > 0 ||
                    parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                      2
                    ) -
                      parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                      0)
                "
              >
                {{
                  currency_formatter(
                    parseFloat(
                      Math.ceil(item.calculations[0].gate_rate_amount)
                    ).toFixed(2)
                  )
                }}
              </span>
            </div>
            <div
              class="result__info-text"
              v-if="
                setbrandid != 'HVN' &&
                (parseFloat(item.total_discount) > 0 ||
                  parseFloat(item.calculations[0].gate_rate_amount).toFixed(2) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2) >
                    0)
              "
            >
              {{ getrans("Savea") }}
              {{
                (
                  ((parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                    2
                  ) -
                    parseFloat(Math.ceil(item.grand_total)).toFixed(2)) /
                    parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                      2
                    )) *
                  100
                ).toFixed(2)
              }}%
            </div>
          </div>
        </div>
        <div class="result__buttons">
          <div
            class="result__button"
            v-if="
              setbrandid == 'RDU' ||
              setbrandid == 'YHM' ||
              setbrandid == 'SV1' ||
              setbrandid == 'OKC' ||
              setbrandid == 'LAX' ||
              setbrandid == 'DEN' ||
              setbrandid == 'SAT' ||
              setbrandid == 'AUH' ||
              setbrandid == 'INV' ||
              setbrandid == 'IP1' ||
              setbrandid == 'LDY' ||
              setbrandid == 'NOC' ||
              setbrandid == 'NQY' ||
              setbrandid == 'BHX' ||
              setbrandid == 'HVN' ||
              setbrandid == 'PIT' ||
              setbrandid == 'YHM' ||
              setbrandid == 'PB1' ||
              setbrandid == 'JER' ||
              setbrandid == 'PV1'
            "
          >
            <button
              :disabled="
                !item.grand_total ||
                item.grand_total == '0.00' ||
                item.booking_applicable == 'N'
              "
              v-if="chkcart === 0"
              @click="
                proceeding_parking[item.carpark_id] = true;
                reserve(
                  item.carpark_id,
                  item.calculations[0].product_id,
                  setbrandid === 'HVN'
                    ? getReservePrice(item)
                    : parseFloat(item.grand_total).toFixed(2),
                  item.carpark_name,
                  false,
                  item
                );
              "
            >
              <i
                v-if="proceeding_parking[item.carpark_id] === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              <template v-if="setbrandid == 'SV1'">{{
                !item.grand_total ||
                item.grand_total == "0.00" ||
                item.booking_applicable == "N"
                  ? unavailable_text
                  : "Continue your adventure"
              }}</template>
              <template v-else-if="setbrandid == 'PB1'">
                {{
                  !item.grand_total ||
                  item.grand_total == "0.00" ||
                  item.booking_applicable == "N"
                    ? parseInt(item.occupancy_percentage) == 100
                      ? getrans("Fully Booked")
                      : getrans(unavailable_text)
                    : getrans(book_button_text)
                }}
              </template>
              <template v-else>{{
                !item.grand_total ||
                item.grand_total == "0.00" ||
                item.booking_applicable == "N"
                  ? getrans(unavailable_text)
                  : getrans(book_button_text)
              }}</template>
              <template v-if="setbrandid == 'HVN'">
                <br/><span class="result-button-subtext">Includes all taxes & fees</span>
              </template>
            </button>
            <button
              v-if="chkcart === 1 && checkproductincart(item.product_id)"
              @click="resetcart"
            >
              <i
                v-if="cancelling_selection === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;Change Selection
            </button>
            <button
              disabled
              v-if="chkcart === 1 && !checkproductincart(item.product_id)"
            >
              <template v-if="setbrandid == 'SV1'">{{
                !item.grand_total ||
                item.grand_total == "0.00" ||
                item.booking_applicable == "N"
                  ? unavailable_text
                  : "Continue your adventure"
              }}</template>
              <template v-else>{{
                !item.grand_total ||
                item.grand_total == "0.00" ||
                item.booking_applicable == "N"
                  ? getrans(unavailable_text)
                  : getrans(book_button_text)
              }}</template>
            </button>
          </div>

          <div class="result__button" v-else-if="setbrandid == 'HER'">
            <button
              :disabled="
                !item.grand_total ||
                item.grand_total == '0.00' ||
                item.booking_applicable == 'N'
              "
              v-if="chkcart === 0"
              @click="
                proceeding_parking[item.carpark_id] = true;
                reserve(
                  item.carpark_id,
                  item.calculations[0].product_id,

                  parseFloat(Math.ceil(item.grand_total)).toFixed(2) -
                    parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                      2
                    ) >
                    0
                    ? parseFloat(item.calculations[0].gate_rate_amount).toFixed(
                        2
                      )
                    : parseFloat(Math.ceil(item.grand_total)).toFixed(2),
                  item.carpark_name,
                  false,
                  item
                );
              "
            >
              <i
                v-if="proceeding_parking[item.carpark_id] === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{
                !item.grand_total ||
                item.grand_total == "0.00" ||
                item.booking_applicable == "N"
                  ? getrans(unavailable_text)
                  : getrans(book_button_text)
              }}
            </button>
            <button
              v-if="chkcart === 1 && checkproductincart(item.product_id)"
              @click="resetcart"
            >
              <i
                v-if="cancelling_selection === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{ getrans("Cancel") }}
            </button>
            <button
              disabled
              v-if="chkcart === 1 && !checkproductincart(item.product_id)"
            >
              {{
                !item.grand_total ||
                item.grand_total == "0.00" ||
                item.booking_applicable == "N"
                  ? getrans(unavailable_text)
                  : getrans(book_button_text)
              }}
            </button>
          </div>

          <div class="result__button" v-else>
            <button
              :disabled="
                !item.grand_total ||
                item.grand_total == '0.00' ||
                item.booking_applicable == 'N'
              "
              v-if="chkcart === 0"
              @click="
                proceeding_parking[item.carpark_id] = true;
                reserve(
                  item.carpark_id,
                  item.calculations[0].product_id,
                  parseFloat(Math.ceil(item.grand_total)).toFixed(2),
                  item.carpark_name,
                  false,
                  item
                );
              "
            >
              <i
                v-if="proceeding_parking[item.carpark_id] === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{
                !item.grand_total ||
                item.grand_total == "0.00" ||
                item.booking_applicable == "N"
                  ? getrans(unavailable_text)
                  : getrans(book_button_text)
              }}
            </button>
            <button
              v-if="chkcart === 1 && checkproductincart(item.product_id)"
              @click="resetcart"
            >
              <i
                v-if="cancelling_selection === true"
                class="fas fa-circle-notch fa-spin"
              ></i
              >&nbsp;
              {{ getrans("Cancel") }}
            </button>
            <button
              disabled
              v-if="chkcart === 1 && !checkproductincart(item.product_id)"
            >
              {{
                !item.grand_total ||
                item.grand_total == "0.00" ||
                item.booking_applicable == "N"
                  ? getrans(unavailable_text)
                  : getrans(book_button_text)
              }}
            </button>
          </div>
        </div>

        <template v-if="setbrandid == 'LAX'">
          <template v-if="item.calculations[0].gate_rate_amount">
            <div class="result__parking-type">
              <template
                v-if="
                  Number(
                    Number(parseFloat(item.calculations[0].gate_rate_amount)) -
                      Number(parseFloat(item.grand_total))
                  ).toFixed(0) === '0'
                "
              >
                {{ getrans("Book now") }}
              </template>
              <template v-else>
                {{ getrans("Book now & save ") }}
                {{
                  currency_formatter(
                    Number(
                      Number(
                        parseFloat(item.calculations[0].gate_rate_amount)
                      ) - Number(parseFloat(item.grand_total))
                    ).toFixed(2)
                  )
                }}
              </template>
            </div>
          </template>
        </template>

        <template v-else>
          <div class="result__parking-type">
            {{
              getrans(decodeQuotes(cpkdetails.clients[item.cpk_pro].feature_4))
            }}
          </div>
        </template>
        <p class="result__details result__details--paragraph">
          {{ getrans(cpkdetails.clients[item.cpk_pro].feature_1) }}&nbsp;{{
            getrans(cpkdetails.clients[item.cpk_pro].feature_2)
          }}&nbsp;{{ getrans(cpkdetails.clients[item.cpk_pro].feature_3) }}
        </p>
        <ul class="result__details result__details--list">
          <li v-if="cpkdetails.clients[item.cpk_pro].feature_1">
            {{ getrans(cpkdetails.clients[item.cpk_pro].feature_1) }}
          </li>
          <li v-if="cpkdetails.clients[item.cpk_pro].feature_2">
            {{ getrans(cpkdetails.clients[item.cpk_pro].feature_2) }}
          </li>
          <li v-if="cpkdetails.clients[item.cpk_pro].feature_3">
            {{ getrans(cpkdetails.clients[item.cpk_pro].feature_3) }}
          </li>
        </ul>
        <template v-if="setbrandid == 'LAX'">
          <div v-if="item.available_slots" class="slots-info-wrap">
            <span
              class="slots-info"
              :class="item.available_slots !== 'NA' ? 'show-slots-info' : ''"
            >
              {{ item.available_slots }}&nbsp;{{
                getrans("spaces left at this price")
              }}
            </span>
          </div>
        </template>
        <div class="result__buttons-secondary">
          <div
            class="result__button result__button-secondary"
            :style="
              get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info')
                ? ''
                : 'display: none;'
            "
          >
            <a
              target="_blank"
              class="result__map-link"
              rel="noopener noreferrer"
              :href="
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info')
              "
              @click.prevent="
                showModal_info[item.cpk_pro] = !showModal_info[item.cpk_pro]
              "
            >
              <button class="list-more-info-button">
                <!-- <img
                class="result__info-image"
                src="@/assets/images/Info.svg"
                alt="user image"
              /> -->
                <InfoIcon />
                <span class="result__info-desktop">{{ getrans("Info") }}</span>
              </button>
            </a>
          </div>
          <div class="result__button result__button-secondary">
            <a
              target="_blank"
              rel="noopener noreferrer"
              :href="
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf')
              "
              :style="
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf')
                  ? ''
                  : 'display: none;'
              "
              @click.prevent="
                showModal_map[item.cpk_pro] = !showModal_map[item.cpk_pro]
              "
            >
              <button class="list-more-info-button">
                <!-- <img
                  class="result__map-image"
                  src="@/assets/images/Map.svg"
                  alt="user image"
                /> -->
                <MapIcon />
                <span class="result__map-desktop">{{ getrans("Map") }}</span>
              </button>
            </a>
          </div>
        </div>
        <div class="result__row-02">
          <div class="result__parking-rating">
            <!-- <div class="result__parking-rating-stars"></div>
            <div class="result__parking-rating-reviews">171 Reviews</div> -->
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <Modal
        :modalWidth="
          isPDF(get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf'))
            ? '100%'
            : 'auto'
        "
        v-if="showModal_map[item.cpk_pro]"
        @close="showModal_map[item.cpk_pro] = false"
      >
        <template v-slot:header>
          <h4>{{ item.carpark_name }} - {{ getrans("Map") }}</h4>
        </template>
        <template v-slot:body>
          <div
            v-if="
              isPDF(get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf'))
            "
            class="map-render--pdf"
            v-html="
              renderMapAsIframe(
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf')
              )
            "
          ></div>
          <div
            style="width: 70vw; height: 80vh"
            v-else-if="
              isHTML(
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf')
              )
            "
            v-html="get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf')"
          ></div>
          <div v-else class="map-render--img">
            <img
              :src="get_lang_image(cpkdetails.clients[item.cpk_pro], 'map_pdf')"
              :alt="`map image of ${item.carpark_name}`"
            />
          </div>
        </template>
      </Modal>
    </transition>

    <transition name="fade">
      <Modal
        :modalWidth="
          isPDF(get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info'))
            ? '100%'
            : 'auto'
        "
        v-if="showModal_info[item.cpk_pro]"
        @close="showModal_info[item.cpk_pro] = false"
      >
        <template v-slot:header>
          <h4>{{ item.carpark_name }} - {{ getrans("More Information") }}</h4>
        </template>
        <template v-slot:body>
          <div
            v-if="
              isPDF(
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info')
              )
            "
            class="map-render--pdf"
            v-html="
              renderMapAsIframe(
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info')
              )
            "
          ></div>
          <div
            style="width: 70vw; height: 80vh"
            v-else-if="
              isHTML(
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info')
              )
            "
            v-html="
              get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info')
            "
          ></div>
          <div v-else class="map-render--img">
            <img
              :src="
                get_lang_image(cpkdetails.clients[item.cpk_pro], 'more_info')
              "
              :alt="`${getrans('More Info')} ${item.carpark_name}`"
            />
          </div>
        </template>
      </Modal>
    </transition>
  </template>

  <transition name="fade">
    <Modal
      :modalWidth="'auto'"
      v-if="showModal_upsell && single_upsell_data"
      @close="
        showModal_upsell = false;
        gotoPage('/yourdetails.html');
      "
    >
      <template v-slot:header>
        <h4 class="upsell-header">{{ getrans(single_upsell_data.header) }}</h4>
      </template>

      <template v-slot:body>
        <template v-for="item in srchres" :key="item">
          <template
            v-if="
              single_upsell_data.suggesstion_sub_product_id ===
              item.calculations[0].product_id
            "
          >
            <div class="upsell-model">
              <h2 class="upsell-model__closer-from">
                {{
                  single_upsell_data.price_change_text
                    ? getrans(single_upsell_data.price_change_text) +
                      " " +
                      currency_formatter(
                        (
                          parseFloat(single_upsell_data.final_amount).toFixed(
                            2
                          ) - parseFloat(pricing_from_searchres).toFixed(2)
                        ).toFixed(2)
                      )
                    : getrans("Get closer to the terminal for just") +
                      " " +
                      currency_formatter(
                        (
                          parseFloat(single_upsell_data.final_amount).toFixed(
                            2
                          ) - parseFloat(pricing_from_searchres).toFixed(2)
                        ).toFixed(2)
                      )
                }}
              </h2>

              <h4 class="upsell-model__carpark-name" v-if="setbrandid == 'LAX'">
                {{ getrans(item.product_display_name) }}
              </h4>
              <h4 class="upsell-model__carpark-name" v-else>
                {{ getrans(item.carpark_name) }}
              </h4>

              <div class="upsell-model__distance-price">
                <div class="result__info-time">
                  <span>{{
                    getrans(cpkdetails.clients[item.cpk_pro].distance_in_time_1)
                  }}</span>
                  <div class="result__info-transfer">
                    <img
                      v-if="cpkdetails.clients[item.cpk_pro].transfer_icon"
                      :src="cpkdetails.clients[item.cpk_pro].transfer_icon"
                    />
                    <img v-else src="@/assets/images/awesome-walking.svg" />
                    {{ getrans("To Terminal") }}
                  </div>
                </div>
                <div class="upsell-model__cost">
                  <h3>
                    {{
                      currency_formatter(
                        parseFloat(single_upsell_data.final_amount).toFixed(2)
                      )
                    }}
                  </h3>
                </div>
              </div>

              <div class="result__parking-data">
                <!-- <p class="result__details result__details--paragraph">
                  {{ getrans(single_upsell_data.tag_line_1) }}&nbsp;{{
                    getrans(single_upsell_data.tag_line_2)
                  }}&nbsp;{{ getrans(single_upsell_data.tag_line_3) }}
                </p> -->
                <ul class="result__details">
                  <li v-if="single_upsell_data.tag_line_1">
                    {{ getrans(single_upsell_data.tag_line_1) }}
                  </li>
                  <li v-if="single_upsell_data.tag_line_2">
                    {{ getrans(single_upsell_data.tag_line_2) }}
                  </li>
                  <li v-if="single_upsell_data.tag_line_3">
                    {{ getrans(single_upsell_data.tag_line_3) }}
                  </li>
                </ul>
              </div>

              <div class="upsell-model__buttons">
                <button
                  :disabled="upsell_loading_button"
                  @click="
                    upsell_loading_button = 'no';
                    getfttvquvenue();
                  "
                  class="upsell-model__buttons-no"
                >
                  <i
                    v-if="upsell_loading_button === 'no'"
                    class="fas fa-circle-notch fa-spin"
                  ></i
                  >&nbsp;
                  {{ getrans("No Thanks") }}
                </button>
                <button
                  class="upsell-model__buttons-yes"
                  :disabled="upsell_loading_button"
                  @click="
                    upsell_loading_button = 'yes';
                    proceeding_parking[item.carpark_id] = true;
                    reserve(
                      item.carpark_id,
                      single_upsell_data.suggesstion_sub_product_id,
                      parseFloat(single_upsell_data.final_amount).toFixed(2),
                      item.carpark_name,
                      true,
                      item
                    );
                  "
                >
                  <i
                    v-if="upsell_loading_button === 'yes'"
                    class="fas fa-circle-notch fa-spin"
                  ></i
                  >&nbsp;
                  {{ getrans("Yes Please! Upgrade and continue") }}
                </button>
              </div>

              <!-- <pre>
              {{ single_upsell_data }}
              </pre> -->
            </div>
          </template>
        </template>
      </template>
    </Modal>
  </transition>
</template>

<script>
const axios = require("axios");
const genkeys = require("rezauthlib");
import Swal from "sweetalert2";
const { v4: uuidv4 } = require("uuid");
const crypto = require("crypto");
import Modal from "../components/Modal.vue";
import MapIcon from "../components/mapIcon.vue";
import InfoIcon from "../components/infoIcon.vue";
import md5 from "js-md5";
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
export default {
  name: "ResultsGrid",
  components: {
    Modal,
    MapIcon,
    InfoIcon,
  },
  props: {
    searchres: undefined,
    color: undefined,
    carparkdetails: undefined,
    parkingproductdetails: undefined,
    date1_date: undefined,
    date2_date: undefined,
    date1_time: undefined,
    date2_time: undefined,
    lang: undefined,
    translations: undefined,
    distances_data: undefined,
    book_button_text: undefined,
  },
  computed: {},
  data() {
    return {
      unavailable_text: "Unavailable",
      upsell_loading_button: false,
      proceeding_parking: [],
      cartdetails: 0,
      chkcart: 0,
      timediffstart: 0,
      showModal_upsell: false,
      single_upsell_data: undefined,
      showModal_map: [],
      cpkdetails: [],
      srchres: [],
      visitortypes: [],
      showModal_info: [],
      venue_select: "",
      feescheck: false,
      venue_select_name: "",
      current_cart: "",
      speedy_email: "",
      speedy_vrn: "",
      setbrandid: "",
      currency: "",
      cancelling_selection: false,
      fttvenues: 0,
      pricing_from_searchres: 0,
    };
  },
  methods: {
    get_distances_data(carpark_id) {
      let data = "";
      this.distances_data.map((item) => {
        if (item.carpark_id === carpark_id) {
          if (item.distance_from_carpark.indexOf(".") > -1) {
            let part1 = item.distance_from_carpark.split(".")[0];
            let part2 = item.distance_from_carpark.split(".")[1];
            data =
              Number(part1).toString() +
              "-" +
              Number(part2).toString() +
              " mins";
          }
        }
      });
      return data;
    },
    getfttvquvenue() {
      let dataa = {
        requireTotalCount: true,
        searchOperation: "contains",
        searchValue: null,
        skip: 0,
        take: 25,
        userData: {},
        sort: null,
        group: null,
        totalSummary: [{ summaryType: "count" }],
        query: {},
        ascending: 1,
        byColumn: 1,
        page: 1,
        limit: 25,
        brand_id: this.setbrandid,
        login_user_id: 1,
      };
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "vqu/backend/venue/list",
          dataa,
          {
            headers: {
              secret_id:
                encryptStorage.getItem("rez_dev_k").VUE_APP_VQUVENUE_SECRETID,
              secret_key:
                encryptStorage.getItem("rez_dev_k").VUE_APP_VQUVENUE_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          let vs = JSON.parse(response.request.response);

          let fttvenues = vs.data;
          console.log("fttvenues", fttvenues);
          if (typeof fttvenues !== "undefined") {
            if (fttvenues.list.length > 0) {
              this.fttvenues = fttvenues.list[0].venue_id;
              encryptStorage.setItem("fttvenues", this.fttvenues);
              console.log("this.fttvenues", this.fttvenues);
            }
          }
          this.getvisitortypes();
        });
    },
    currency_formatter(money) {
      if (!money) return;
      const arrayString = process.env.VUE_APP_CURRENCY_AFTER_VALUE;
      const array = JSON.parse(arrayString);
      if (array.includes(this.setbrandid)) {
        money = money.toString().replace(".", ",");
        return money + " " + this.currency;
      }
      return this.currency + " " + money;
    },
    get_lang_image(cpk, prefix) {
      if (!cpk) {
        return "";
      }
      if (cpk[`${prefix}_${this.lang.toLowerCase()}`]) {
        return cpk[`${prefix}_${this.lang.toLowerCase()}`];
      } else if (cpk[`${prefix}_en`]) {
        return cpk[`${prefix}_en`];
      } else {
        return cpk[`${prefix}`];
      }
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);
      return this.translations[ss] || string;
    },
    decodeQuotes(str) {
      return str.replace(/&#39;/g, "'");
    },
    isPDF(img) {
      if (/\.pdf$/.test(img)) {
        return true;
      }
      return false;
    },
    isHTML(img) {
      if (img && img.indexOf("!DOCTYPE html") > -1) {
        return true;
      }
      return false;
    },
    renderMapAsIframe(img) {
      return `<iframe src="${img}" width="100%" height="100%"></iframe>`;
    },
    gotoPage(url) {
      window.location.href = url;
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    checkdateequal(dt, tt, offset) {
      let dt1 = dt.replace("/", "-");
      dt1 = dt1.replace("/", "-");
      dt1 = dt1 + "T" + tt + ":00" + offset;
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      let dtt = [year, month, day].join("-");
      console.info(dtt);
      let dt2 = new Date();
      dt1 = new Date(dt1);
      let t1 = dt1.getTime();
      let t2 = dt2.getTime();
      let t3 = dt1 - dt2;
      t3 = t3 / (1000 * 60 * 60);
      console.info("t1", t1);
      console.info("t2", t2);
      console.info("t3", t3);
      let b = 0;
      if (this.setbrandid === "YHM") {
        if (t3 < 4) {
          b = 0;
        } else {
          b = 1;
        }
      } else {
        if (t3 < 24) {
          b = 0;
        } else {
          b = 1;
        }
      }
      return b;
    },
    formatDateymd_dashed(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },
    reserve(
      carpark_id,
      product_id,
      price,
      carpark_name,
      upsell_clicked = false,
      item
    ) {
      if (parseFloat(price) > 0) {
        let currency = "GBP";
        if (this.usDBrands().indexOf(this.setbrandid) > -1) {
          currency = "USD";
        }
        if (this.euRBrands().indexOf(this.setbrandid) > -1) {
          currency = "EUR";
        }

        const addToCartPayload = {
          event: "add_to_cart",
          ecommerce: {
            currency,
            value: Number(parseFloat(price).toFixed(2)),
            items: [
              {
                item_id: item.product_id,
                item_name: item.product_display_name,
                item_category: "Parking",
                price: Number(parseFloat(price).toFixed(2)),
                quantity: 1,
                item_entry_date: this.formatDateymd_dashed(this.date1_date),
                item_entry_time: this.date1_time,
                item_exit_date: this.formatDateymd_dashed(this.date2_date),
                item_exit_time: this.date2_time,
                item_list_id: this.setbrandid.toLowerCase() + "_cpk_list",
                item_list_name:
                  this.setbrandid.toUpperCase() + " Carpark Search Result List",
                venue: this.venue_select_name,
              },
            ],
          },
        };

        if (this.setbrandid === "PV1") {
          addToCartPayload.ecommerce.send_to = "AW-16447517358/Wt3nCJX9vZcZEK7l5KI9";
        }

        if (this.setbrandid === "LDY" || this.setbrandid === "NOC") {
          let datalayerparams = encryptStorage.getItem("datalayerparams") || {};
          if (typeof datalayerparams !== "object" || datalayerparams === null) {
            datalayerparams = {};
          }
          if (Object.prototype.hasOwnProperty.call(datalayerparams, "cpk")) {
            delete datalayerparams.cpk;
          }
          datalayerparams.cpk = addToCartPayload;
          encryptStorage.setItem("datalayerparams", datalayerparams);

          /* eslint-disable */
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({ ecommerce: null });
          dataLayer.push(addToCartPayload);
          /* eslint-enable */
        }

        this.resetpromocode();

        if (!upsell_clicked) {
          // Swal.fire({
          //   icon: "info",
          //   text: "Checking offers - Please wait",
          //   showCloseButton: false,
          //   showConfirmButton: false,
          // });
          Swal.fire({
            html: `<div style="padding: 0.5rem 0 0;">
            <h2 style="color:var(--result_title_font_color, #0a3b74)">
              ${this.getrans("Please wait")}
            </h2><i style="font-size: 32px; padding: 1rem; color: var(--result_time_dist_font_color, #0a3b74)" class="fas fa-circle-notch fa-spin"></i>
          </div>`,
            showCloseButton: false,
            showConfirmButton: false,
          });
        }

        setTimeout(function () {
          encryptStorage.removeItem("dis_cpk");
          encryptStorage.removeItem("dis_ftt");
          encryptStorage.removeItem("discount_amount");
          encryptStorage.removeItem("discount_amount_applied");
          encryptStorage.removeItem("discount_coupon_applied");
        }, 3000);
        let orefwithoutprefix = encryptStorage.getItem("orefwithoutprefix");
        if (typeof orefwithoutprefix !== "undefined") {
          orefwithoutprefix = encryptStorage.getItem("orefwithoutprefix");
        } else {
          orefwithoutprefix = new Date().getTime();
          encryptStorage.setItem("orefwithoutprefix", orefwithoutprefix);
        }
        //let order_ref = this.setbrandid + "-CPK-" + +new Date().getTime();
        let order_ref = this.setbrandid + "-CPK-" + orefwithoutprefix;
        let data = {
          carpark_id: carpark_id,
          product_id: product_id,
          venue_id: this.venue_select,
          brand_id: this.setbrandid,
          booking_ref_id: order_ref,
          uuid: this.genuuid(),
          valid_from: this.date1_date,
          valid_till: this.date2_date,
          start_time: this.date1_time,
          end_time: this.date2_time,
          slots_to_book: 1,
        };
        let cartdata = {
          carpark_id: carpark_id,
          product_id: product_id,
          product_code: item.carpark_identifier,
          product_name: item.product_display_name,
          product_display_name: item.product_display_name,
          venue_id: this.venue_select,
          venue_select_name: this.venue_select_name,
          brand_id: this.setbrandid,
          booking_ref_id: order_ref,
          orefwithoutprefix: orefwithoutprefix,
          uuid: this.genuuid(),
          valid_from: this.date1_date,
          valid_till: this.date2_date,
          start_time: this.date1_time,
          end_time: this.date2_time,
          slots_to_book: 1,
          price: price,
          carpark_name: carpark_name,
        };
        if (this.setbrandid === "HVN") {
          const hvnBreakdown = this.getHvnFeeBreakdown(item);
          cartdata.fees_applicable = "Y";
          cartdata.space_charges = hvnBreakdown.spaceCharges.toFixed(2);
          cartdata.booking_fee = hvnBreakdown.bookingFee.toFixed(2);
          cartdata.booking_fee_name =
            hvnBreakdown.bookingFeeName || "Reservation Fee";
          cartdata.fees_amount = hvnBreakdown.taxAmount.toFixed(2);
          cartdata.tax_fee = hvnBreakdown.taxAmount.toFixed(2);
          cartdata.tax_name = hvnBreakdown.taxName || "Tax 6.35%";
          cartdata.fees_policy_name = hvnBreakdown.taxName || "Tax 6.35%";
          cartdata.pricefeesdisplay =
            "Parking Fees " +
            this.currency +
            cartdata.space_charges +
            " + " +
            cartdata.booking_fee_name +
            " " +
            this.currency +
            cartdata.booking_fee +
            " + " +
            cartdata.fees_policy_name +
            " " +
            this.currency +
            cartdata.fees_amount;
        }
        if (upsell_clicked) {
          cartdata.upsell = "1";
        }
        if (this.setbrandid == "SV1") {
          let space_charges = parseFloat(cartdata.price).toFixed(2);
          let tax_fee = (parseFloat(cartdata.price) * 0.14).toFixed(2);
          let grand_total = parseFloat(cartdata.price) + parseFloat(tax_fee);
          grand_total = parseFloat(grand_total).toFixed(2);
          grand_total = Math.ceil(grand_total * 100) / 100;
          cartdata.fees_applicable = "Y";
          cartdata.tax_fee = tax_fee;
          cartdata.tax_name = "HST";
          cartdata.fees_amount = tax_fee;

          cartdata.fees_policy_name = "HST 14%";
          cartdata.space_charges = space_charges;
          let pricefeesdisplay =
            "Parking Fees " + this.currency + cartdata.space_charges;
          pricefeesdisplay =
            pricefeesdisplay +
            " + " +
            cartdata.fees_policy_name +
            " " +
            this.currency +
            cartdata.fees_amount;
          cartdata.pricefeesdisplay = pricefeesdisplay;
          cartdata.fees = {
            booking_type: "B",
            action_applicable: "Y",
            calculation_type: "P",
            fees_amount: cartdata.fees_amount,
            tax_rate_on_product: 14,
            policy_name: "HST",
            applyontax: "1",
          };
          cartdata.price = grand_total.toFixed(2);
        }
        let bb = 0;
        if (
          this.setbrandid == "RDU" ||
          this.setbrandid == "YHM" ||
          this.setbrandid == "OKC"
        ) {
          bb = this.checkdateequal(this.date1_date, this.date1_time, "-05:00");
        } else {
          bb = 1;
        }
        if (bb == 1) {
          encryptStorage.setItem("cart", JSON.stringify(cartdata));
          encryptStorage.setItem("cpkitemincart", JSON.stringify(item));
          if (encryptStorage.getItem("oldcart") === undefined) {
            encryptStorage.setItem("oldcart", JSON.stringify(cartdata));
            encryptStorage.setItem("cpkitemincart", JSON.stringify(item));
          }
          encryptStorage.setItem("tag_totcost", price);
          encryptStorage.setItem("order_ref", order_ref);
          encryptStorage.setItem("order_ref_remove", order_ref);

          let secsa = genkeys(
            encryptStorage.getItem("rez_dev_k").VUE_APP_RESERVE_SECRETID,
            encryptStorage.getItem("rez_dev_k").VUE_APP_RESERVE_SECRETKEY
          );
          let b1s = secsa.b1s;
          let v2s = secsa.v2s;
          let a1 = secsa.a1;
          let v1 = secsa.v1;
          let c2s = secsa.c2s;
          let uidgen = secsa.uidgen;
          axios
            .post(
              encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
                "parking/frontend/carpark/slots/reserve",
              data,
              {
                headers: {
                  b1: b1s,
                  v2: v2s,
                  c2s: c2s,
                  a1: a1,
                  v1: v1,
                  c1: uidgen,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              let datasent = JSON.parse(response.request.response);
              if (datasent.user_exists == "Y") {
                if (this.feescheck) {
                  this.verify_fee_charges(
                    order_ref,
                    price,
                    cartdata,
                    upsell_clicked
                  );
                } else {
                  if (!upsell_clicked) {
                    this.upsellcheck(cartdata);
                  } else {
                    this.getfttvquvenue();
                  }
                }
              } else {
                Swal.fire(
                  this.getrans("Error!"),
                  this.getrans(datasent.data),
                  "error"
                );
                this.proceeding_parking[carpark_id] = false;
              }
            });
        } else {
          let resevtaion_err_msg =
            "Reservations within 24 hours of arrival, are unavailable online.";
          if (this.setbrandid == "YHM") {
            resevtaion_err_msg =
              "Reservations cannot be booked less than 4 hours in advance of arrival at the Airport.";
          }
          Swal.fire(
            this.getrans("Error!"),
            this.getrans(resevtaion_err_msg),
            "error"
          );
          this.proceeding_parking[carpark_id] = false;
        }
      } else {
        Swal.fire(
          this.getrans("Error!"),
          this.getrans(
            "Reservation error, cannot proceed, please try again later."
          ),
          "error"
        );
      }

      let airline_select = sessionStorage.getItem("airline_select") || "";
      if (airline_select) {
        sessionStorage.setItem("airline_select_booked", airline_select);
      }
    },
    usDBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_USD);
      } catch (e) {
        console.error("Failed to parse VUE_APP_USD:", e);
        return [];
      }
    },
    gbPBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_GBP);
      } catch (e) {
        console.error("Failed to parse VUE_APP_GBP:", e);
        return [];
      }
    },
    euRBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_EUR);
      } catch (e) {
        console.error("Failed to parse VUE_APP_EUR:", e);
        return [];
      }
    },
    gaGtmBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_GTM);
      } catch (e) {
        console.error("Failed to parse VUE_APP_GTM:", e);
        return [];
      }
    },
    verify_fee_charges(orderref, ordertotal, cartdata, upsell_clicked) {
      let dsa_date_string = "";
      if (
        this.setbrandid == "RDU" ||
        this.setbrandid == "YHM" ||
        this.setbrandid == "SV1" ||
        this.setbrandid == "OKC" ||
        this.setbrandid == "LAX" ||
        this.setbrandid == "DEN" ||
        this.setbrandid == "SAT" ||
        this.setbrandid == "HVN" ||
        this.setbrandid == "PIT" ||
        this.setbrandid == "PV1"
      ) {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "US/Eastern",
        });
      }
      if (this.setbrandid == "HER") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Asia/Nicosia",
        });
      }
      if (this.setbrandid == "NWI") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/London",
        });
      }
      if (this.setbrandid == "AIR") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/London",
        });
      }
      if (this.setbrandid == "PB1") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/Berlin",
        });
      }
      if (this.setbrandid == "AUH") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Asia/Dubai",
        });
      }
      dsa_date_string = dsa_date_string.split(",");
      let datepart_str = dsa_date_string[0].split("/");
      let datenow =
        datepart_str[2] +
        "-" +
        datepart_str[1] +
        "-" +
        datepart_str[0] +
        " " +
        dsa_date_string[1];
      let chdata =
        encryptStorage.getItem("rez_dev_k").VUE_APP_CANAMN +
        this.setbrandid +
        orderref +
        ordertotal;
      let hash = crypto.createHash("sha512");
      let hash_data = hash.update(chdata, "utf-8").digest("hex");

      let datacancel = {
        brand_id: this.setbrandid,
        product_id: "cpk",
        venue_id: cartdata.venue_id,
        booking_ref_id: orderref,
        sub_product_id: cartdata.product_id,
        booking_date_time: datenow,
        entry_date_time: cartdata.valid_from + " " + cartdata.start_time,
        gross_total: ordertotal,
        fees_for: "B",
        hash_data: hash_data,
      };
      console.log("cartdata", cartdata);
      console.log("datacancel", datacancel);
      let secsaaip_all = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_CANAMN_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_CANAMN_SECRETKEY
      );
      let ur = "fees/frontend/config/view";

      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO + ur,
          datacancel,
          {
            headers: {
              b1: secsaaip_all.b1s,
              v2: secsaaip_all.v2s,
              c2s: secsaaip_all.c2s,
              a1: secsaaip_all.a1,
              v1: secsaaip_all.v1,
              c1: secsaaip_all.uidgen,
            },
          }
        )
        .then((response) => {
          let codesent = JSON.parse(response.request.response);
          console.log("verify_fee_charges", codesent);

          if (codesent.status) {
            let st = codesent.status;
            if (st == "success") {
              let dta = codesent.data;
              let dt = "";
              let booking_fee_name = "";
              let tax_name = "";
              let booking_fee = 0;
              let tax_fee = 0;
              for (let n = 0; n < dta.length; n++) {
                let item_fee = dta[n];
                console.log("item_fee", item_fee);
                if (item_fee.show_on_website == "Y") {
                  if (item_fee.calculation_type == "B") {
                    console.log("item_fee bfees", item_fee);
                    booking_fee_name = item_fee.policy_name;
                    booking_fee =
                      item_fee.calculation[0].total_amount ||
                      item_fee.calculation[0].total_amount;
                    if (item_fee.calculation[0].tax_rate_on_fees) {
                      encryptStorage.setItem(
                        "tax_rate_on_fees",
                        item_fee.calculation[0].tax_rate_on_fees
                      );
                    }
                    encryptStorage.setItem("booking_fee", booking_fee);
                    encryptStorage.setItem(
                      "booking_fee_name",
                      booking_fee_name
                    );
                    dt = item_fee;
                  }
                  if (item_fee.calculation_type == "T") {
                    console.log("item_fee others", item_fee);
                    tax_name = item_fee.policy_name;
                    tax_fee = item_fee.calculation[0].tax_amount;
                    dt = item_fee;
                    encryptStorage.setItem("tax_name", tax_name);
                    encryptStorage.setItem("tax_fee", tax_fee);
                  }
                }
              }

              console.log("dt", dt);
              console.log("booking_fee", booking_fee);
              let policy_name = "";
              if (dt.policy_name) {
                policy_name = dt.policy_name;
              }
              if (dt.calculation) {
                if (dt.calculation[0]) {
                  let action_applicable = dt.calculation[0].action_applicable;
                  let totchangedprice = 0;
                  if (action_applicable == "Y") {
                    if (booking_fee != "") {
                      //let grand_total = dt.calculation[0].grand_total;
                      //grand_total = parseFloat(grand_total);
                      //grand_total = Math.ceil(grand_total * 100) / 100;
                      cartdata.fees_applicable = "Y";
                      cartdata.booking_fee = booking_fee;
                      cartdata.booking_fee_name = booking_fee_name;
                      dt.calculation[0].policy_name = policy_name;
                      cartdata.fees = dt.calculation[0];
                      //console.log("cartdata.fees_amount", grand_total);
                      //cartdata.fees_amount = grand_total;
                      //console.log("cartdata.fees_amount", cartdata.fees_amount);
                      cartdata.fees_policy_name = policy_name;
                      cartdata.space_charges = cartdata.price;
                      totchangedprice =
                        totchangedprice + parseFloat(cartdata.booking_fee);
                    }
                    if (tax_fee != "") {
                      let grand_total = dt.calculation[0].tax_amount;
                      if(this.setbrandid=='HVN')
                    {
                      grand_total = parseFloat(grand_total) + parseFloat(cartdata.booking_fee)*0.0635;
                    }
                      console.log(
                        "cartdata.fees_amount grand_total",
                        grand_total
                      );
                      grand_total = parseFloat(grand_total);
                      grand_total = Math.ceil(grand_total * 100) / 100;
                      cartdata.fees_applicable = "Y";
                      cartdata.tax_fee = tax_fee;
                      cartdata.tax_name = tax_name;
                      dt.calculation[0].policy_name = policy_name;
                      dt.calculation[0].calculation_type = "P";

                      cartdata.fees = dt.calculation[0];
                      console.log("cartdata.fees_amount", grand_total);
                      cartdata.fees_amount = grand_total;
                      console.log("cartdata.fees_amount", cartdata.fees_amount);
                      cartdata.fees_policy_name = policy_name;
                      cartdata.space_charges = cartdata.price;
                      totchangedprice =
                        totchangedprice + parseFloat(cartdata.fees_amount);
                    }
                    totchangedprice =
                      totchangedprice + parseFloat(cartdata.price);
                    let pricefeesdisplay =
                      "Parking Fees " + this.currency + cartdata.price;
                    if (parseFloat(cartdata.booking_fee) > 0) {
                      pricefeesdisplay =
                        pricefeesdisplay +
                        " + " +
                        cartdata.booking_fee_name +
                        " " +
                        this.currency +
                        cartdata.booking_fee;
                    }
                    if (parseFloat(cartdata.fees_amount) > 0) {
                      pricefeesdisplay =
                        pricefeesdisplay +
                        " + " +
                        cartdata.fees_policy_name +
                        " " +
                        this.currency +
                        cartdata.fees_amount;
                    }
                    cartdata.pricefeesdisplay = pricefeesdisplay;
                    cartdata.price = totchangedprice.toFixed(2);

                    console.log("cartdata after fees", cartdata);
                    encryptStorage.setItem("cart", JSON.stringify(cartdata));
                    encryptStorage.setItem("tag_totcost", cartdata.price);
                    if (!upsell_clicked) {
                      this.upsellcheck(cartdata);
                    } else {
                      this.getfttvquvenue();
                    }
                  } else {
                    cartdata.fees_applicable = "N";
                    if (this.setbrandid == "SV1") {
                      cartdata.fees_applicable = "Y";
                    }
                    encryptStorage.setItem("cart", JSON.stringify(cartdata));
                    if (!upsell_clicked) {
                      this.upsellcheck(cartdata);
                    } else {
                      this.getfttvquvenue();
                    }
                  }
                } else {
                  cartdata.fees_applicable = "N";
                  if (this.setbrandid == "SV1") {
                    cartdata.fees_applicable = "Y";
                  }
                  encryptStorage.setItem("cart", JSON.stringify(cartdata));
                  if (!upsell_clicked) {
                    this.upsellcheck(cartdata);
                  } else {
                    this.getfttvquvenue();
                  }
                }
              } else {
                cartdata.fees_applicable = "N";
                if (this.setbrandid == "SV1") {
                  cartdata.fees_applicable = "Y";
                }
                encryptStorage.setItem("cart", JSON.stringify(cartdata));
                if (!upsell_clicked) {
                  this.upsellcheck(cartdata);
                } else {
                  this.getfttvquvenue();
                }
              }
            } else {
              cartdata.fees_applicable = "N";
              if (this.setbrandid == "SV1") {
                cartdata.fees_applicable = "Y";
              }
              encryptStorage.setItem("cart", JSON.stringify(cartdata));
              if (!upsell_clicked) {
                this.upsellcheck(cartdata);
              } else {
                this.getfttvquvenue();
              }
            }
          } else {
            cartdata.fees_applicable = "N";
            if (this.setbrandid == "SV1") {
              cartdata.fees_applicable = "Y";
            }
            encryptStorage.setItem("cart", JSON.stringify(cartdata));
            if (!upsell_clicked) {
              this.upsellcheck(cartdata);
            } else {
              this.getfttvquvenue();
            }
          }
        });
    },
    upsellcheck(cartdata) {
      let dsa_date_string = "";
      if (
        this.setbrandid == "RDU" ||
        this.setbrandid == "YHM" ||
        this.setbrandid == "SV1" ||
        this.setbrandid == "OKC" ||
        this.setbrandid == "PIT" ||
        this.setbrandid == "RSW" ||
        this.setbrandid == "SAT" ||
        this.setbrandid == "YHM" ||
        this.setbrandid == "PV1"
      ) {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "US/Eastern",
        });
      }
      if (this.setbrandid == "HER") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Asia/Nicosia",
        });
      }
      if (
        this.setbrandid == "NWI" ||
        this.setbrandid == "NOC" ||
        this.setbrandid == "LDY" ||
        this.setbrandid == "JER"
      ) {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/London",
        });
      }
      if (this.setbrandid == "AIR") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/London",
        });
      }
      if (this.setbrandid == "PB1") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/Berlin",
        });
      }
      if (this.setbrandid == "AUH") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Asia/Dubai",
        });
      }
      if (this.setbrandid == "LAX") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "America/Los_Angeles",
        });
      }
      if (this.setbrandid == "SZG") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Europe/Vienna",
        });
      }
      if (this.setbrandid == "DRW" || this.setbrandid == "ASP") {
        dsa_date_string = new Date().toLocaleString("en-GB", {
          timeZone: "Australia/Darwin",
        });
      }
      dsa_date_string = dsa_date_string.split(",");
      let datepart_str = dsa_date_string[0].split("/");
      let datenow =
        datepart_str[2] +
        "-" +
        datepart_str[1] +
        "-" +
        datepart_str[0] +
        " " +
        dsa_date_string[1];
      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_USLCHK_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_USLCHK_SECRETKEY
      );
      let resul = [];
      console.log("this.searchres", this.searchres);
      console.log("this.searchres.length", this.searchres.length);
      let pricing_from_searchres = 0;
      Object.entries(this.srchres).forEach((entry) => {
        const [key, value] = entry;
        console.log("key", key);
        let p = parseFloat(value.grand_total); // Convert to number
        if (p > 0) {
          let pid = value.calculations[0].product_id;
          if (pid.toString() == cartdata.product_id.toString()) {
            //alert(pid.toString());
            //alert(cartdata.product_id.toString());
            pricing_from_searchres = p;
            // alert(pricing_from_searchres);
          }
          let a = {
            sub_product_id: pid,
            amount: p,
          };
          resul.push(a);
        }
      });
      this.pricing_from_searchres = pricing_from_searchres;
      let data = {
        brand_id: this.setbrandid,
        product_id: "CPK",
        selected_sub_product_id: cartdata.product_id,
        selected_sub_product_amount: parseFloat(pricing_from_searchres).toFixed(
          2
        ),
        booking_date_time: datenow,
        entry_date: cartdata.valid_from,
        exit_date: cartdata.valid_till,
        start_time: cartdata.start_time,
        exit_time: cartdata.end_time,
        sub_products: resul,
      };
      let datacsl = {
        brand_id: this.setbrandid,
        product_id: "CPK",
        venue_id: this.venue_select,
        venue_select_name: this.venue_select_name,
        selected_sub_product_id: cartdata.product_id,
        selected_sub_product_amount: parseFloat(pricing_from_searchres).toFixed(
          2
        ),
        booking_date_time: datenow,
        entry_date: cartdata.valid_from,
        exit_date: cartdata.valid_till,
        start_time: cartdata.start_time,
        exit_time: cartdata.end_time,
      };
      encryptStorage.setItem("datacsl", datacsl);
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "upsell/frontend/upsell_availability/view",
          data,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          Swal.close();

          let datasent = JSON.parse(response.request.response);
          let user_exists = datasent.user_exists;
          if (user_exists == "Y" && Array.isArray(datasent.data)) {
            encryptStorage.setItem("upsell_shown", "Yes");
            encryptStorage.setItem("upsell_data", datasent);
            encryptStorage.setItem("curr_search_results", this.searchres);
            if (datasent && datasent.data && datasent.data.length === 1) {
              this.showModal_upsell = true;
              this.current_cart = encryptStorage.getItem("cart");
              this.single_upsell_data = datasent.data[0];
            } else if (datasent && datasent.data && datasent.data.length > 1) {
              this.gotoPage("/upsell.html");
            }
            //console.log("curr_search_results", this.searchres);
            //this.gotoPage("/upsell.html");
          } else {
            encryptStorage.setItem("upsell_shown", "No");
            this.getfttvquvenue();
          }
        });
    },
    getvisitortypes() {
      let dataa = {
        requireTotalCount: true,
        searchOperation: "contains",
        searchValue: null,
        skip: 0,
        take: 25,
        userData: {},
        sort: null,
        group: null,
        totalSummary: [{ summaryType: "count" }],
        query: {},
        ascending: 1,
        byColumn: 1,
        page: 1,
        limit: 25,
        brand_id: this.setbrandid,
      };
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "lounge/backend/visitor_type/list",
          dataa,
          {
            headers: {
              secret_id: "ffda61dc9d474d6575d5bc26915aea64",
              secret_key:
                "e299ed60ce833168490712a6cd9c7c1a0c20eec766fced527520118f586cd156",
              "Content-Type": "application/json",
            },
          }
        )
        .then(
          (response) => {
            //console.log(response);
            let vs = JSON.parse(response.request.response);
            this.visitortypes = vs.data;
            this.crosssellcheck();
          },
          (error) => {
            console.log(error);
            encryptStorage.setItem("crosssell_shown", "No");
            this.gotoPage("/yourdetails.html");
          }
        );
    },
    crosssellcheck() {
      let vis = [];
      let cvis = 0;
      let avis = 0;
      let ivis = 0;
      for (let a = 0; a < this.visitortypes.length; a++) {
        let visitem = this.visitortypes[a];
        if (visitem.visitor_type_name == "Child" && visitem.status == "A") {
          cvis = visitem.visitor_type_id;
        }
        if (visitem.visitor_type_name == "Adult" && visitem.status == "A") {
          avis = visitem.visitor_type_id;
        }
        if (visitem.visitor_type_name == "Infant" && visitem.status == "A") {
          ivis = visitem.visitor_type_id;
        }
      }
      if (parseInt(avis) > 0) {
        let it = {};
        it.visitor_type_id = avis;
        it.count = 1;
        vis.push(it);
      }
      if (parseInt(cvis) > 0) {
        let ita = {};
        ita.visitor_type_id = cvis;
        ita.count = 1;
        vis.push(ita);
      }
      if (parseInt(ivis) > 0) {
        let iti = {};
        iti.visitor_type_id = ivis;
        iti.count = 1;
        vis.push(iti);
      }

      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_CSLCHK_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_CSLCHK_SECRETKEY
      );
      let datacsl = encryptStorage.getItem("datacsl");
      if (vis.length > 0) {
        datacsl.lounge = { visitors: vis };
      }
      if (parseInt(this.fttvenues) > 0) {
        let fasttrack_arr = [];
        let outbound_ftt = {
          guid: this.genuuid(),
          entry_date: datacsl.entry_date,
          start_time: datacsl.start_time,
          unit_data: { ADL: 1 },
          lane_type: "outbound",
          venue_id: this.fttvenues,
        };
        let inbound_ftt = {
          guid: this.genuuid(),
          entry_date: datacsl.exit_date,
          start_time: datacsl.exit_time,
          unit_data: { ADL: 1 },
          lane_type: "inbound",
          venue_id: this.fttvenues,
        };
        fasttrack_arr.push(outbound_ftt);
        fasttrack_arr.push(inbound_ftt);
        datacsl.fasttrack = fasttrack_arr;
      }
      encryptStorage.setItem("datacsl", datacsl);
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
            "cross_sell/frontend/availability/view",
          datacsl,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          Swal.close();

          let datasent = JSON.parse(response.request.response);
          let user_exists = datasent.user_exists;
          if (user_exists == "Y") {
            encryptStorage.setItem("crosssell_shown", "Yes");
            encryptStorage.setItem("crosssell_data", datasent);
            console.log("crosssell_data", datasent);
            encryptStorage.setItem("curr_search_results", this.searchres);
            console.log("datasent.data.length", datasent.data.length);
            let adhoc_count_cross = 0;
            let normal_count_cross = 0;
            for (let z = 0; z < datasent.data.length; z++) {
              console.log("suggestion_type", datasent.data[z].suggestion_type);
              console.log("status", datasent.data[z].status);
              if (
                datasent.data[z].suggestion_type == "A" &&
                datasent.data[z].status == "success"
              ) {
                adhoc_count_cross++;
              }
              if (
                datasent.data[z].suggestion_type == "R" &&
                datasent.data[z].status == "success"
              ) {
                normal_count_cross++;
              }
            }
            console.log("adhoc_count_cross", adhoc_count_cross);
            if (adhoc_count_cross == 0) {
              if (normal_count_cross > 0) {
                this.gotoPage("/crosssell.html");
              } else {
                this.gotoPage("/yourdetails.html");
              }
            } else {
              this.gotoPage("/crossselladhoc.html");
            }
          } else {
            encryptStorage.setItem("crosssell_shown", "No");
            this.gotoPage("/yourdetails.html");
          }
        });
    },
    genuuid() {
      if (sessionStorage.getItem("uuid") === null) {
        let uuidgen = uuidv4();
        this.setLocalData("uuid", uuidgen);
        return uuidgen;
      } else {
        return sessionStorage.getItem("uuid");
      }
    },
    checkproductincart(carpark_id) {
      if (this.cartdetails === carpark_id) {
        return true;
      } else {
        return false;
      }
    },
    resetpromocode() {
      let order_ref = encryptStorage.getItem("order_ref");
      let discount_coupon_applied = encryptStorage.getItem(
        "discount_coupon_applied"
      );
      if (typeof discount_coupon_applied !== "undefined") {
        let cartdata = {
          brand_id: this.setbrandid,
          booking_ref_id: order_ref,
          uuid: this.genuuid(),
          promo_code: discount_coupon_applied,
        };
        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_LIVESSO +
              "discount/frontend/promo_code/cancel",
            cartdata,
            {
              headers: {
                secret_id:
                  encryptStorage.getItem("rez_dev_k")
                    .VUE_APP_LOUNGE_RPROMO_SECRETID,
                secret_key:
                  encryptStorage.getItem("rez_dev_k")
                    .VUE_APP_LOUNGE_RPROMO_SECRETKEY,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log(response);
          });
      }
    },
    resetcart() {
      this.cancelling_selection = true;
      this.resetpromocode();
      setTimeout(function () {
        sessionStorage.removeItem("cart");
        encryptStorage.removeItem("dis_cpk");
        encryptStorage.removeItem("dis_ftt");
        encryptStorage.removeItem("discount_amount");
        encryptStorage.removeItem("discount_amount_applied");
        encryptStorage.removeItem("discount_coupon_applied");
        window.location.reload();
      }, 3000);
    },
    getbranded() {
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/getbrnslg_dev.php",
          "",
          {
            headers: {
              secret_id:
                encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key:
                encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.currency = response.data.currency;
            if (
              response.data.slug == "HER" ||
              response.data.slug == "NOC" ||
              response.data.slug == "SZG" ||
              response.data.slug == "FM1" ||
              response.data.slug == "BRE" ||
              response.data.slug == "PB1"
            ) {
              this.currency = "€";
            }
            // if (this.setbrandid === "PB1") {
            //   this.unavailable_text = "Fully booked";
            //
            if (this.setbrandid === "LAX") {
              this.unavailable_text = "Sold Out";
            }
            if (this.setbrandid === "PIT") {
              this.unavailable_text = "Sold Out";
            }
            if (
              response.data.slug == "PV1" ||
              response.data.slug == "PIT" ||
              response.data.slug == "HVN"
            ) {
              this.feescheck = true;
            }
          }
        });
    },
    async get_rez_data_k() {
      if (typeof encryptStorage.getItem("rez_dev_k") === "undefined") {
        let _this = this;
        await axios
          .get("https://devhub.rezcomm.com/hubapmydbauth/livedata/index.php")
          .then((response) => {
            const key = "XwB?au@qy*^y!r6R&wV8fVuSXmGKf3Sn";
            const encryptedData = response.data;
            let dec = _this.decrypt_custom(key, encryptedData);

            encryptStorage.setItem("rez_dev_k", dec);
          })
          .then(() => {
            _this.getbranded();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.getbranded();
      }
    },
    decrypt_custom(key, data) {
      const decodedData = Buffer.from(data, "base64").toString("utf8");
      const parts = decodedData.split("::");

      // Extract IV
      key = Buffer.from(parts[0]);
      let iv = Buffer.from(parts[2], "hex");

      // Extract encrypted data
      const encryptedData = Buffer.from(parts[1], "base64");

      // Create decipher object with correct IV and key
      const decipher = crypto.createDecipheriv("aes-256-cbc", key, iv);

      // Update decryption with encrypted data
      let decrypted = decipher.update(encryptedData);

      // Finalize the decryption
      decrypted = Buffer.concat([decrypted, decipher.final()]);

      return decrypted.toString("utf8");
    },
    roundFeeAmount(amount) {
      amount = parseFloat(amount);
      if (Number.isNaN(amount)) {
        return 0;
      }
      return parseFloat(amount.toFixed(2));
    },
    getPrebookFeeDetails() {
      let pfeedetails = encryptStorage.getItem("pfeedetails");
      if (!pfeedetails) {
        return null;
      }
      if (typeof pfeedetails === "string") {
        try {
          pfeedetails = JSON.parse(pfeedetails);
        } catch (error) {
          return null;
        }
      }
      return pfeedetails;
    },
    getFeePolicyByType(pfeedetails, calculationType) {
      if (!pfeedetails) {
        return null;
      }
      if (Array.isArray(pfeedetails)) {
        return (
          pfeedetails.find(
            (policy) => policy.calculation_type === calculationType
          ) || null
        );
      }
      if (Array.isArray(pfeedetails.policies)) {
        return (
          pfeedetails.policies.find(
            (policy) => policy.calculation_type === calculationType
          ) || null
        );
      }
      if (
        pfeedetails.calculation_type === calculationType &&
        Array.isArray(pfeedetails.calculation)
      ) {
        return pfeedetails;
      }
      if (calculationType === "B" && pfeedetails.booking_fee_policy) {
        return pfeedetails.booking_fee_policy;
      }
      if (calculationType === "T" && pfeedetails.tax_policy) {
        return pfeedetails.tax_policy;
      }
      return null;
    },
    getHvnAdditionalCharges(item) {
      const breakdown = this.getHvnFeeBreakdown(item);
      if (breakdown.additionalCharges > 0) {
        return breakdown.additionalCharges;
      }
      return parseFloat(this.parking_additional_value) || 0;
    },
    getHvnFeeBreakdown(item) {
      const baseAmount = parseFloat(item && item.grand_total);
      if (Number.isNaN(baseAmount)) {
        return {
          spaceCharges: 0,
          bookingFee: 0,
          taxAmount: 0,
          additionalCharges: parseFloat(this.parking_additional_value) || 0,
          bookingFeeName: "Reservation Fee",
          taxName: "Tax 6.35%",
        };
      }
      const pfeedetails = this.getPrebookFeeDetails();
      const bookingPolicy = this.getFeePolicyByType(pfeedetails, "B");
      const taxPolicy = this.getFeePolicyByType(pfeedetails, "T");
      let bookingFee = 0;
      let taxAmount = 0;
      let bookingFeeName = "Reservation Fee";
      let taxName = "Tax 6.35%";

      if (
        bookingPolicy &&
        Array.isArray(bookingPolicy.calculation) &&
        bookingPolicy.calculation[0]
      ) {
        bookingFeeName = bookingPolicy.policy_name || bookingFeeName;
        const bookingCalculation = bookingPolicy.calculation[0];
        const calculationType = bookingCalculation.calculation_type;
        const calculationValue =
          parseFloat(bookingCalculation.calculation_value) || 0;
        const minimumFees = parseFloat(bookingCalculation.minimum_fees) || 0;
        const maximumFees = parseFloat(bookingCalculation.maximum_fees) || 0;

        if (calculationType === "P") {
          bookingFee = (baseAmount * calculationValue) / 100;
        } else {
          bookingFee = calculationValue;
        }

        if (minimumFees > 0 && bookingFee < minimumFees) {
          bookingFee = minimumFees;
        }
        if (maximumFees > 0 && bookingFee > maximumFees) {
          bookingFee = maximumFees;
        }

        bookingFee = this.roundFeeAmount(bookingFee);
      }

      if (
        taxPolicy &&
        Array.isArray(taxPolicy.calculation) &&
        taxPolicy.calculation[0]
      ) {
        taxName = taxPolicy.policy_name || taxName;
        const taxCalculation = taxPolicy.calculation[0];
        const taxRateOnProduct =
          parseFloat(taxCalculation.tax_rate_on_product) || 0;
        const taxRateOnFees =
          parseFloat(taxCalculation.tax_rate_on_fees) || 0;
        const productTax = (baseAmount * taxRateOnProduct) / 100;
        const feeTax = (bookingFee * taxRateOnFees) / 100;
        taxAmount = this.roundFeeAmount(productTax + feeTax);
      }

      const additionalCharges = bookingFee + taxAmount;
      return {
        spaceCharges: baseAmount,
        bookingFee,
        taxAmount,
        additionalCharges,
        bookingFeeName,
        taxName,
      };
    },
    getItemAdditionalCharges(item) {
      if (this.setbrandid === "HVN") {
        return this.getHvnAdditionalCharges(item);
      }
      return parseFloat(this.parking_additional_value) || 0;
    },
    getDisplayPrice(item) {
      const baseAmount = parseFloat(item && item.grand_total) || 0;
      const additionalCharges = this.getItemAdditionalCharges(item);
      return (baseAmount + additionalCharges).toFixed(2);
    },
    getReservePrice(item) {
      return this.getDisplayPrice(item);
    },
  },
  mounted() {
    this.get_rez_data_k();
    const urlParams = new URLSearchParams(window.location.search);
    this.venue_select = urlParams.get("venue_select");
    this.venue_select_name = urlParams.get("venue_select_name");
    encryptStorage.setItem(
      "venue_select_name_original_product",
      this.venue_select_name
    );
    let edate = new Date(this.date1_date + " " + this.date1_time);
    let now = new Date();
    let diff = (edate - now) / 1000;
    this.timediffstart = diff;

    console.log("parkingproductdetails", this.parkingproductdetails);
    console.log("carparkdetails", this.carparkdetails);
    console.log("searchres", this.searchres);

    let srchres = [];
    let cpl = {};
    let cpkdetails = [];
    let cpk_products = {};

    for (const key in this.searchres) {
      let res_items = this.searchres[key];
      let cpkitem_id = res_items.carpark_id;
      let pritem_id = res_items.product_id;
      res_items.cpk_pro = cpkitem_id + "_" + pritem_id;
      srchres.push(res_items);
      cpk_products[pritem_id] = {};
      cpk_products[pritem_id]["product_name"] = res_items.product_display_name;
      if (this.parkingproductdetails.clients[pritem_id]) {
        let n = this.parkingproductdetails.clients[pritem_id];
        console.log("show_in_frontend", n);
        let show_in_frontend = n.show_in_frontend;
        console.log("show_in_frontend", show_in_frontend);
        if (show_in_frontend == "true") {
          let b = this.parkingproductdetails.clients[pritem_id];
          b.carpark_id = cpkitem_id;

          cpkdetails[cpkitem_id + "_" + pritem_id] =
            this.parkingproductdetails.clients[pritem_id];
        } else {
          let c = this.carparkdetails.clients[cpkitem_id];

          cpkdetails[cpkitem_id + "_" + pritem_id] = c;
        }
      } else {
        let c = this.carparkdetails.clients[cpkitem_id];

        cpkdetails[cpkitem_id + "_" + pritem_id] = c;
      }
    }
    this.srchres = srchres;
    cpl.clients = cpkdetails;
    this.cpkdetails = cpl;
    console.log("cpkdetails", this.cpkdetails);
    sessionStorage.setItem("cpk_products", JSON.stringify(cpk_products));

    if (encryptStorage.getItem("cart") === undefined) {
      this.cartdetails = 0;
      this.chkcart = 0;
    } else {
      let crt = encryptStorage.getItem("cart");
      this.cartdetails = crt.product_id;
      this.chkcart = 1;
    }
  },
  updated() {},
};
</script>

<style lang="scss">
.swal2-popup.swal2-popup {
  width: auto;
}
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";
.result {
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #dfdfdf;
  margin-bottom: 3rem;

  &__column {
    &-right {
      width: 40%;
    }

    &-left {
      width: 60%;
    }
  }

  &__row {
    &-01 {
      display: flex;
      flex-direction: row;
      align-items: center;

      @media screen and (max-width: 1024px) {
        align-items: flex-start;
      }
    }

    &-02 {
      padding: 1rem 0;
      height: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #dfdfdf;
      text-align: center;
    }
  }

  &__parking {
    &-icon {
      width: 100%;
      img {
        width: 100%;
        height: auto;
      }

      &.color-01 {
        //background-color: #3bbdd1;
      }

      &.color-02 {
        background-color: #3bbdd1;
      }

      &.color-03 {
        background-color: #0a3b74;
      }

      &.color-04 {
        background-color: #a8a8a8;
      }
    }
    &-data {
      padding-left: 1.875rem;
      padding-top: 23px;

      ul {
        columns: 2;
        padding: 0;

        @media screen and (max-width: 1024px) {
          columns: 1;
        }

        li {
          padding: 0;
          margin: 0;
          list-style-position: inside;
          line-height: 1.4;
          color: #707070;
          font-size: 0.875rem;
        }
      }
    }
    &-rating {
      padding-left: 0.875rem;
      &-reviews {
        font-size: 0.875rem;
      }
    }
    &-type {
      padding: 0.8rem 1rem 0.5rem;
      text-align: center;
      border-top: 1px solid #dfdfdf;
      font-family: var(--result_tagline_font_family, inherit);
      font-size: var(--result_tagline_font_size, 1rem);
      font-weight: var(--result_tagline_font_weight, 700);
      color: var(--result_tagline_font_color, #0a3b74);
      display: flex;
      min-height: 6rem;
      justify-content: center;
      align-items: center;
    }
  }

  &__headline {
    font-family: var(--result_title_font_family, inherit);
    font-size: var(--result_title_font_size, 16px);
    font-weight: var(--result_title_font_weight, 700);
    color: var(--result_title_font_color, #0a3b74);
  }

  &__right-row {
    &-01 {
      height: 50%;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      flex-direction: row;
      align-items: center;
      min-height: 7.75rem;
    }

    &-02 {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 50%;
    }
  }

  &__info,
  &__map {
    color: #0a3b74;
    font-size: 1.5rem;
    width: 100%;
    max-width: 6rem;
    height: 100%;
    text-align: center;
    border-right: 1px solid #dfdfdf;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    cursor: pointer;
    @media screen and (min-width: 992px) {
      max-width: 10rem;
    }
  }

  &__info-image,
  &__map-image {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.5rem;
  }

  &__button {
    flex: 1;
    padding-right: 1rem;
    padding-left: 1rem;
    // padding-top: 1.5rem;

    button {
      width: 100%;
      background-color: #034a94;
      color: #ffffff;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 8px;
      height: 55px;
      border: none;
    }
    button:disabled {
      filter: saturate(0);
      cursor: not-allowed;
    }
  }

  &__distance {
    border-right: 1px solid #dfdfdf;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    flex-direction: column;
    font-size: 12px;

    // enable once ready
    .result__info-transfer {
      background: var(--result_time_dist_transfer_background, #0a3b74);
      color: var(--result_time_dist_transfer_font_color, #fff);
      padding: 0.2rem 0.6rem;
      border-radius: 1rem;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: auto;
        height: 16px;
        margin-right: 0.25rem;
      }
    }
  }

  &__info-time {
    //color: #034a94;
    span {
      font-family: var(--result_time_dist_font_family, inherit);
      font-size: var(--result_time_dist_font_size, 1.2rem);
      font-weight: var(--result_time_dist_font_weight, 600);
      color: var(--result_time_dist_font_color, #0a3b74);
    }
  }

  &__cost {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    flex-direction: column;
    font-size: 12px;
  }

  margin-left: 15px;
  margin-right: 15px;
  box-sizing: border-box;
  width: auto;

  &-grid {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  &__headline {
    text-align: center;
    font-size: 18pt;
    margin: 0;
    padding: 1rem;
    border-bottom: 1px solid #dfdfdf;
  }

  &__column {
    &-left,
    &-right {
      width: 100%;
    }

    &-left {
      .result__row-01 {
        flex-direction: column;
      }
    }
  }

  &__parking {
    &-icon {
      width: 100%;
    }
  }

  &__right-row-01 {
    padding: 0;
    border-bottom: 1px solid #dfdfdf;
    margin: 0;
    margin-bottom: 0.5rem;
  }

  &__distance,
  &__cost {
    padding: 1rem 0;
  }

  &__distance {
    border: none;
    border-right: 1px solid #dfdfdf;
  }

  &__info-cost {
    font-family: var(--result_price_font_family, inherit);
    font-size: var(--result_price_font_size, 1.5rem);
    font-weight: var(--result_price_font_weight, bold);
    color: var(--result_price_font_color, #0a3b74);
    text-align: center;
  }

  &__info-cost-total_amount {
    text-decoration: line-through;
    margin: 0.5rem;
    font-family: var(--result_price_subtext_font_family, inherit);
    font-size: var(--result_price_subtext_font_size, 0.9rem);
    font-weight: var(--result_price_subtext_font_weight, bold);
    color: var(--result_price_subtext_font_color, #7a8390);
  }

  &__info-text {
    font-family: var(--result_time_dist_subtext_font_family, inherit);
    font-size: var(--result_time_dist_subtext_font_size, 0.825rem);
    font-weight: var(--result_time_dist_subtext_font_weight, bold);
    color: var(--result_time_dist_subtext_font_color, #0a3b74);
  }

  &__map-desktop,
  &__info-desktop {
    // color: #0a3b74;
    // font-weight: normal;
    font-family: var(--result_button_secondary_font_family, inherit);
    font-size: var(--result_button_secondary_font_size, 1.324rem);
    font-weight: var(--result_button_secondary_font_weight, normal);
    color: var(--result_button_secondary_font_color, #0a3b74);
  }

  &__buttons,
  &__data {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  &__buttons {
    padding-bottom: 0.5rem;

    div:first-child {
      // margin-left: 1rem;
    }

    button {
      width: 100%;
      background-color: var(--result_button_primary_background, #034a94);
      color: var(--result_button_primary_font_color, #ffffff);
      border-radius: var(--result_button_primary_border_radius, 8px);
      box-shadow: 0px 3px 6px #00000029;
      border: none;
      padding: 0.5rem;
      font-size: 1.325rem;
      font-weight: bold;
    }
  }

  &__button-secondary button {
    //background-color: #e9e7e7;
    //color: #0a3b74;
    font-family: var(--result_button_secondary_font_family, inherit);
    font-size: var(--result_button_secondary_font_size, 1.324rem);
    font-weight: var(--result_button_secondary_font_weight, normal);
    color: var(--result_button_secondary_font_color, #0a3b74);
    background: var(--result_button_secondary_background, #e9e7e7);
    border: var(--result_button_secondary_border, none);
    border-radius: var(--result_button_secondary_border_radius, 4px);
  }

  &__details {
    padding: 0.5rem;
    margin: 0;
    margin-bottom: 0.5rem;
    border-top: 1px solid #dfdfdf;
    border-bottom: 1px solid #dfdfdf;
    text-align: center;
    li {
      list-style-position: inside;
      // list-style: none;
      width: auto;
    }

    &--list {
      display: var(--details_as_list, flex);
      //display: none;
      font-size: 0.9rem;
      margin: 0.3rem auto;
      color: #707070;
      width: 100%;

      justify-content: center;
      align-items: center;
      flex-direction: column;
      min-height: 8rem;
      gap: 0.2rem;
    }

    &--paragraph {
      display: var(--details_as_paragraph, block);
      //display: block;
      font-size: 1rem;
      margin: 0.3rem auto;
      padding: 1rem;
      color: #707070;
    }
  }
}

.fade-in {
  opacity: 0;
  animation: fadeIn 0.3s normal forwards ease-in-out;
  -webkit-animation: fadeIn 0.3s normal forwards ease-in-out;
  -moz-animation: fadeIn 0.3s normal forwards ease-in-out;
  -o-animation: fadeIn 0.3s normal forwards ease-in-out;
  -ms-animation: fadeIn 0.3s normal forwards ease-in-out;
}

.map-render--pdf {
  min-width: 300px;
  min-height: 300px;
  height: 80vh;
  width: 100%;
  position: relative;
  display: flex;
  iframe {
    width: 1000px;
  }
}

.map-render--img {
  min-width: 300px;
  max-width: 900px;
  height: auto;
  position: relative;
  display: flex;
  img {
    width: 100%;
  }
}

.result-disabled {
  // display: none;
  filter: saturate(0);
  .result__info-cost {
    color: #999;
  }
}

.list-more-info-button {
  margin-left: 0rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.result__buttons-secondary {
  display: flex;
  gap: 1rem;
  padding: 0.5rem 1rem 1rem;
  .result__button-secondary {
    padding: 0;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.upsell-header {
  text-align: left;
  font-family: var(--result_title_font_family, inherit);
  font-size: var(--result_title_font_size, 1rem);
  font-weight: var(--result_title_font_weight, 700);
  color: var(--result_title_font_color, #0a3b74);
}
.upsell-model {
  max-width: 500px;
  &__closer-from {
    padding: 1.5rem 3rem;
    text-align: center;
    font-family: var(--upsell_popup_font_family, inherit);
    font-size: var(--upsell_popup_font_size, 2rem);
    font-weight: var(--upsell_popup_font_weight, 700);
    color: var(--upsell_popup_font_color, #0a3b74);
    background: var(--upsell_popup_background, #f6f6f6);
  }
  &__carpark-name {
    text-align: center;
    padding: 0.5rem 3rem;
    font-weight: bold;
  }
  &__cost {
    h3 {
      font-family: var(--result_price_font_family, inherit);
      font-size: var(--result_price_font_size, 1.5rem);
      font-weight: var(--result_price_font_weight, bold);
      color: var(--result_price_font_color, #0a3b74);
    }
  }
  &__buttons {
    border-top: 1px solid #e6e6e6;
    padding: 1rem 1rem 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 1rem 0;
    gap: 1rem;
    button {
      border-radius: 0;
      padding: 1rem;
      flex: auto 1;
      &.upsell-model__buttons-no {
        font-family: var(--result_button_secondary_font_family, inherit);
        font-weight: var(--result_button_secondary_font_weight, bold);
        color: var(--result_button_secondary_font_color, #0a3b74);
        background: var(--result_button_secondary_background, #e9e7e7);
        border: var(--result_button_secondary_border, none);
        border-radius: var(--result_button_secondary_border_radius, 4px);
      }
      &.upsell-model__buttons-yes {
        font-family: var(--result_button_secondary_font_family, inherit);
        font-weight: var(--result_button_secondary_font_weight, bold);
        background-color: var(--result_button_primary_background, #034a94);
        color: var(--result_button_primary_font_color, #ffffff);
        border: var(--result_button_secondary_border, none);
        border-radius: var(--result_button_secondary_border_radius, 4px);
      }
    }
  }
  &__distance-price {
    border-top: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    display: flex;
    flex-direction: row;
    width: 100%;
    div {
      display: flex;
      flex-direction: column;
      flex: 1;
      text-align: center;
      padding: 1rem 3rem;
      border-right: 1px solid #e6e6e6;
      &:last-child {
        border-right: none;
      }
    }
    .result__info-transfer {
      width: auto;
      display: inline-block;
      background: var(--result_time_dist_transfer_background, #0a3b74);
      color: var(--result_time_dist_transfer_font_color, #fff);
      padding: 0.2rem 0.6rem;
      border-radius: 1rem;
      font-size: 12px;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      img {
        width: auto;
        height: 16px;
        margin-right: 0.25rem;
      }
    }
  }
  .result__parking-data {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 1rem 0;
    ul {
      columns: initial;
      border-top: 0px solid #dfdfdf;
      border-bottom: 0px solid #dfdfdf;
      text-align: center;
      li {
        list-style-position: inside;
        margin: 0.5rem;
      }
    }
  }
}

.result__info-cost-grand_total {
  display: block;
}

.RSW .result__info-time {
  text-align: center;
}
.featured-product {
  position: relative;
  border: 3px solid #440099;
}

.featured-product-header {
  position: absolute;
  top: 0px;
  transform: translateY(-100%);
  background: #440099;
  color: #fff;
  width: 100%;
  text-align: center;
  padding: 0.25rem;
  outline: 3px solid #440099;
}

.slots-info-wrap {
  .slots-info {
    opacity: 0;
    padding: 0.3rem;
    display: block;
    text-align: center;
    font-weight: bold;
  }
  .slots-info.show-slots-info {
    opacity: 1;
    background: #ff8039;
    color: #fff;
  }
}
</style>
